// extracted by mini-css-extract-plugin
export default {"answer":"zba-z","bestAnswerHeading":"Aba-z","meta":"Bba-z"};